import { getRecordValue } from '../../../../helpers/safeRecordAccess';
import type { FormType } from '../../types/dashboard.types';

interface TypeBadgeProps {
  type: FormType;
}

const typeStyles: Record<FormType, { bg: string; text: string }> = {
  auto: { bg: 'bg-[#DBEAFE]', text: 'text-[#1E40AF]' },
  life: { bg: 'bg-[#E0E7FF]', text: 'text-[#3730A3]' },
  disability: { bg: 'bg-[#D1FAE5]', text: 'text-[#065F46]' },
  health: { bg: 'bg-[#EDE9FE]', text: 'text-[#5B21B6]' },
  home: { bg: 'bg-[#FEF3C7]', text: 'text-[#92400E]' },
};

const typeLabels: Record<FormType, string> = {
  auto: 'AUTO',
  life: 'LIFE',
  disability: 'DISABILITY',
  health: 'HEALTH',
  home: 'HOME',
};

export function TypeBadge({ type }: TypeBadgeProps) {
  const styles = getRecordValue(typeStyles, type);

  return (
    <span
      className={`inline-flex items-center justify-center rounded px-2 py-1 text-[11px] font-semibold ${styles.bg} ${styles.text}`}
    >
      {getRecordValue(typeLabels, type)}
    </span>
  );
}
